import { PAGE_REGISTRY, type PageEntry } from "./pages";
import { RELATED_PAGE_SLUGS } from "./pages-related";

/** Pages shown as standalone links in header nav (daily-use only: Rashifal, Panchang, Calendar) */
export function getHeaderPages(): PageEntry[] {
  return PAGE_REGISTRY.filter((p) => p.headerNav && !p.hindi).sort(
    (a, b) => (b.priority ?? 50) - (a.priority ?? 50)
  );
}

/** Pages shown in the "Tools" header dropdown (top 14 by priority) */
export function getToolsDropdownPages(): PageEntry[] {
  return PAGE_REGISTRY.filter((p) => p.toolsDropdown && !p.hindi)
    .sort((a, b) => (b.priority ?? 50) - (a.priority ?? 50))
    .slice(0, 14);
}

/** Pages grouped by category for footer */
export function getFooterGroups(): Record<string, PageEntry[]> {
  const groups: Record<string, PageEntry[]> = {};
  for (const page of PAGE_REGISTRY) {
    if (page.hindi || page.hideFromFooter) continue;
    const cat = page.category;
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(page);
  }
  for (const cat of Object.keys(groups)) {
    groups[cat].sort((a, b) => (b.priority ?? 50) - (a.priority ?? 50));
  }
  return groups;
}

/** Category display names for footer headings */
export const CATEGORY_LABELS: Record<string, string> = {
  calculator: "Calculators",
  rashifal: "Rashifal",
  tool: "Daily Tools",
  dosha: "Doshas & Remedies",
  reference: "Learn",
};

/** All pages for cross-link component (excluding current).
 *  Semantically related pages appear first; remainder is priority-sorted. */
export function getCrossLinkPages(currentSlug: string): PageEntry[] {
  const relatedSlugs = RELATED_PAGE_SLUGS[currentSlug] ?? [];
  const relatedPages = relatedSlugs
    .map((slug) => PAGE_REGISTRY.find((p) => p.slug === slug))
    .filter((p): p is PageEntry => p != null && !p.hindi);

  const relatedSet = new Set([currentSlug, ...relatedSlugs]);
  const rest = PAGE_REGISTRY.filter(
    (p) => !relatedSet.has(p.slug) && !p.hindi && p.category !== "reference"
  ).sort((a, b) => (b.priority ?? 50) - (a.priority ?? 50));

  return [...relatedPages, ...rest];
}

/** All pages not in header or Tools dropdown (used as fallback "More" list in mobile) */
export function getMorePages(): PageEntry[] {
  return PAGE_REGISTRY.filter(
    (p) => !p.headerNav && !p.toolsDropdown && !p.hindi && !p.hideFromFooter
  ).sort((a, b) => (b.priority ?? 50) - (a.priority ?? 50));
}
